module.exports = __webpack_public_path__ + "img/pl.7cbd647f.svg";